/**
 * Permission constants matching the backend RBAC system.
 * Use these constants for permission checks throughout the app.
 */

// =========================================
// Asset Management
// =========================================
export const ASSET_READ = 'asset:read';
export const ASSET_CREATE = 'asset:create';
export const ASSET_UPDATE = 'asset:update';
export const ASSET_DELETE = 'asset:delete';
export const ASSET_TRANSFER = 'asset:transfer';

// =========================================
// Asset Issue Management
// =========================================
export const ASSET_ISSUE_READ = 'asset-issue:read';
export const ASSET_ISSUE_CREATE = 'asset-issue:create';
export const ASSET_ISSUE_UPDATE = 'asset-issue:update';
export const ASSET_ISSUE_DELETE = 'asset-issue:delete';
export const ASSET_ISSUE_ASSIGN = 'asset-issue:assign';

// =========================================
// Service Management
// =========================================
export const SERVICE_READ = 'service:read';
export const SERVICE_CREATE = 'service:create';
export const SERVICE_UPDATE = 'service:update';
export const SERVICE_DELETE = 'service:delete';
export const SERVICE_ASSIGN = 'service:assign';

// =========================================
// Preventive Work Order Management
// =========================================
export const PREVENTIVE_READ = 'preventive:read';
export const PREVENTIVE_CREATE = 'preventive:create';
export const PREVENTIVE_UPDATE = 'preventive:update';
export const PREVENTIVE_DELETE = 'preventive:delete';
export const PREVENTIVE_ASSIGN = 'preventive:assign';

// =========================================
// Recall Work Order Management
// =========================================
export const RECALL_READ = 'recall:read';
export const RECALL_CREATE = 'recall:create';
export const RECALL_UPDATE = 'recall:update';
export const RECALL_DELETE = 'recall:delete';
export const RECALL_ASSIGN = 'recall:assign';

// =========================================
// Routine Check Management
// =========================================
export const ROUTINE_READ = 'routine:read';
export const ROUTINE_CREATE = 'routine:create';
export const ROUTINE_UPDATE = 'routine:update';
export const ROUTINE_DELETE = 'routine:delete';

// =========================================
// Calibration Management
// =========================================
export const CALIBRATION_READ = 'calibration:read';
export const CALIBRATION_CREATE = 'calibration:create';
export const CALIBRATION_UPDATE = 'calibration:update';
export const CALIBRATION_DELETE = 'calibration:delete';

// =========================================
// Testing Management
// =========================================
export const TESTING_READ = 'testing:read';
export const TESTING_CREATE = 'testing:create';
export const TESTING_UPDATE = 'testing:update';
export const TESTING_DELETE = 'testing:delete';

// =========================================
// User Management
// =========================================
export const USER_READ = 'user:read';
export const USER_CREATE = 'user:create';
export const USER_UPDATE = 'user:update';
export const USER_DELETE = 'user:delete';

// =========================================
// Organization Management
// =========================================
export const ORGANIZATION_READ = 'organization:read';
export const ORGANIZATION_MANAGE = 'organization:manage';

// =========================================
// Role & Permission Management
// =========================================
export const ROLE_READ = 'role:read';
export const ROLE_MANAGE = 'role:manage';
export const PERMISSION_READ = 'permission:read';
export const PERMISSION_ASSIGN = 'permission:assign';

// =========================================
// Maintenance Management
// =========================================
export const MAINTENANCE_READ = 'maintenance:read';
export const MAINTENANCE_CREATE = 'maintenance:create';
export const MAINTENANCE_UPDATE = 'maintenance:update';
export const MAINTENANCE_DELETE = 'maintenance:delete';
export const MAINTENANCE_MANAGE = 'maintenance:manage';

// =========================================
// Consumables Inventory
// =========================================
export const CONSUMABLES_READ = 'consumables:read';
export const CONSUMABLES_CREATE = 'consumables:create';
export const CONSUMABLES_UPDATE = 'consumables:update';
export const CONSUMABLES_DELETE = 'consumables:delete';

// =========================================
// Spare Parts Inventory
// =========================================
export const SPARE_PART_READ = 'spare-part:read';
export const SPARE_PART_CREATE = 'spare-part:create';
export const SPARE_PART_UPDATE = 'spare-part:update';
export const SPARE_PART_DELETE = 'spare-part:delete';

// =========================================
// Spare Part Type Management
// =========================================
export const SPARE_PART_TYPE_READ = 'spare-part-type:read';
export const SPARE_PART_TYPE_CREATE = 'spare-part-type:create';
export const SPARE_PART_TYPE_UPDATE = 'spare-part-type:update';
export const SPARE_PART_TYPE_DELETE = 'spare-part-type:delete';

// =========================================
// Tool Management
// =========================================
export const TOOL_READ = 'tool:read';
export const TOOL_CREATE = 'tool:create';
export const TOOL_UPDATE = 'tool:update';
export const TOOL_DELETE = 'tool:delete';

// =========================================
// Vendor Management
// =========================================
export const VENDOR_READ = 'vendor:read';
export const VENDOR_CREATE = 'vendor:create';
export const VENDOR_UPDATE = 'vendor:update';
export const VENDOR_DELETE = 'vendor:delete';

// =========================================
// Location Management
// =========================================
export const LOCATION_READ = 'location:read';
export const LOCATION_CREATE = 'location:create';
export const LOCATION_UPDATE = 'location:update';
export const LOCATION_DELETE = 'location:delete';

// =========================================
// Warranty Management
// =========================================
export const WARRANTY_READ = 'warranty:read';
export const WARRANTY_CREATE = 'warranty:create';
export const WARRANTY_UPDATE = 'warranty:update';
export const WARRANTY_DELETE = 'warranty:delete';

// =========================================
// Tag (NFC/RFID) Management
// =========================================
export const TAG_READ = 'tag:read';
export const TAG_CREATE = 'tag:create';
export const TAG_UPDATE = 'tag:update';
export const TAG_DELETE = 'tag:delete';

// =========================================
// Equipment Catalog
// =========================================
export const EQUIPMENT_READ = 'equipment:read';
export const EQUIPMENT_CREATE = 'equipment:create';
export const EQUIPMENT_UPDATE = 'equipment:update';
export const EQUIPMENT_DELETE = 'equipment:delete';

// =========================================
// Equipment Requests
// =========================================
export const EQUIPMENT_REQUEST_READ = 'equipment-request:read';
export const EQUIPMENT_REQUEST_CREATE = 'equipment-request:create';
export const EQUIPMENT_REQUEST_UPDATE = 'equipment-request:update';
export const EQUIPMENT_REQUEST_DELETE = 'equipment-request:delete';

// =========================================
// Invitation Management
// =========================================
export const INVITATION_CREATE = 'invitation:create';
export const INVITATION_READ = 'invitation:read';
export const INVITATION_CANCEL = 'invitation:cancel';

// =========================================
// Notification Management
// =========================================
export const NOTIFICATION_READ = 'notification:read';
export const NOTIFICATION_CREATE = 'notification:create';
export const NOTIFICATION_DELETE = 'notification:delete';

// =========================================
// Attendance Management
// =========================================
export const ATTENDANCE_READ = 'attendance:read';
export const ATTENDANCE_CREATE = 'attendance:create';
export const ATTENDANCE_UPDATE = 'attendance:update';

// =========================================
// Activity Log
// =========================================
export const ACTIVITY_READ = 'activity:read';

// =========================================
// Reports
// =========================================
export const REPORT_VIEW = 'report:view';
export const REPORT_EXPORT = 'report:export';
export const COST_REPORT_VIEW = 'cost:report:view';

// =========================================
// Department Management
// =========================================
export const DEPARTMENT_READ = 'department:read';
export const DEPARTMENT_MANAGE = 'department:manage';

// =========================================
// Service Contracts
// =========================================
export const SERVICE_CONTRACT_READ = 'service-contract:read';
export const SERVICE_CONTRACT_CREATE = 'service-contract:create';
export const SERVICE_CONTRACT_UPDATE = 'service-contract:update';
export const SERVICE_CONTRACT_DELETE = 'service-contract:delete';

// =========================================
// Escalation Management
// =========================================
export const ESCALATION_READ = 'escalation:read';
export const ESCALATION_CREATE = 'escalation:create';
export const ESCALATION_UPDATE = 'escalation:update';
export const ESCALATION_DELETE = 'escalation:delete';

// =========================================
// Meter Management
// =========================================
export const METER_READ = 'meter:read';
export const METER_CREATE = 'meter:create';
export const METER_UPDATE = 'meter:update';
export const METER_DELETE = 'meter:delete';

// =========================================
// Service Requests
// =========================================
export const SERVICE_REQUEST_READ = 'service-request:read';
export const SERVICE_REQUEST_CREATE = 'service-request:create';
export const SERVICE_REQUEST_UPDATE = 'service-request:update';
export const SERVICE_REQUEST_DELETE = 'service-request:delete';

// =========================================
// Procurement (Planning & Purchasing)
// =========================================
export const PROCUREMENT_REQUEST_READ = 'procurement-request:read';
export const PROCUREMENT_REQUEST_CREATE = 'procurement-request:create';
export const PROCUREMENT_REQUEST_RESOLVE = 'procurement-request:resolve';
export const PURCHASE_ORDER_READ = 'purchase-order:read';
export const PURCHASE_ORDER_CREATE = 'purchase-order:create';
export const PURCHASE_ORDER_UPDATE = 'purchase-order:update';
export const PURCHASE_ORDER_DELETE = 'purchase-order:delete';
export const PROCUREMENT_ANALYTICS = 'procurement:analytics';

// =========================================
// Category Management
// =========================================
export const CATEGORY_READ = 'category:read';
export const CATEGORY_CREATE = 'category:create';
export const CATEGORY_UPDATE = 'category:update';
export const CATEGORY_DELETE = 'category:delete';

// =========================================
// Asset Type Management
// =========================================
export const ASSET_TYPE_READ = 'asset-type:read';
export const ASSET_TYPE_CREATE = 'asset-type:create';
export const ASSET_TYPE_UPDATE = 'asset-type:update';
export const ASSET_TYPE_DELETE = 'asset-type:delete';

// =========================================
// Custom Field Management
// =========================================
export const CUSTOM_FIELD_CREATE = 'custom-field:create';
export const CUSTOM_FIELD_UPDATE = 'custom-field:update';
export const CUSTOM_FIELD_DELETE = 'custom-field:delete';

// =========================================
// Materiovigilance (Compliance)
// =========================================
export const MATERIOVIGILANCE_READ   = 'materiovigilance:read';
export const MATERIOVIGILANCE_CREATE = 'materiovigilance:create';
export const MATERIOVIGILANCE_UPDATE = 'materiovigilance:update';
export const MATERIOVIGILANCE_DELETE = 'materiovigilance:delete';
export const MATERIOVIGILANCE_CLOSE  = 'materiovigilance:close';
export const MATERIOVIGILANCE_REOPEN = 'materiovigilance:reopen';

// =========================================
// Document Vault (Compliance — organization certificates)
// =========================================
export const DOCUMENT_VAULT_READ   = 'document-vault:read';
export const DOCUMENT_VAULT_CREATE = 'document-vault:create';
export const DOCUMENT_VAULT_UPDATE = 'document-vault:update';
export const DOCUMENT_VAULT_DELETE = 'document-vault:delete';

// =========================================
// Team Management
// =========================================
export const TEAM_READ            = 'team:read';
export const TEAM_CREATE          = 'team:create';
export const TEAM_UPDATE          = 'team:update';
export const TEAM_DELETE          = 'team:delete';
export const TEAM_MANAGE_MEMBERS  = 'team:manage-members';

// =========================================
// Permission Groups (for feature access)
// =========================================
export const ASSET_PERMISSIONS = [
  ASSET_READ,
  ASSET_CREATE,
  ASSET_UPDATE,
  ASSET_DELETE,
  ASSET_TRANSFER,
];

export const ASSET_ISSUE_PERMISSIONS = [
  ASSET_ISSUE_READ,
  ASSET_ISSUE_CREATE,
  ASSET_ISSUE_UPDATE,
  ASSET_ISSUE_DELETE,
  ASSET_ISSUE_ASSIGN,
];

export const SERVICE_PERMISSIONS = [
  SERVICE_READ,
  SERVICE_CREATE,
  SERVICE_UPDATE,
  SERVICE_DELETE,
  SERVICE_ASSIGN,
];

export const PREVENTIVE_PERMISSIONS = [
  PREVENTIVE_READ,
  PREVENTIVE_CREATE,
  PREVENTIVE_UPDATE,
  PREVENTIVE_DELETE,
  PREVENTIVE_ASSIGN,
];

export const RECALL_PERMISSIONS = [
  RECALL_READ,
  RECALL_CREATE,
  RECALL_UPDATE,
  RECALL_DELETE,
  RECALL_ASSIGN,
];

export const ROUTINE_PERMISSIONS = [
  ROUTINE_READ,
  ROUTINE_CREATE,
  ROUTINE_UPDATE,
  ROUTINE_DELETE,
];

export const CALIBRATION_PERMISSIONS = [
  CALIBRATION_READ,
  CALIBRATION_CREATE,
  CALIBRATION_UPDATE,
  CALIBRATION_DELETE,
];

export const TESTING_PERMISSIONS = [
  TESTING_READ,
  TESTING_CREATE,
  TESTING_UPDATE,
  TESTING_DELETE,
];

export const USER_PERMISSIONS = [
  USER_READ,
  USER_CREATE,
  USER_UPDATE,
  USER_DELETE,
];

export const ORGANIZATION_PERMISSIONS = [
  ORGANIZATION_READ,
  ORGANIZATION_MANAGE,
];

export const RBAC_PERMISSIONS = [
  ROLE_READ,
  ROLE_MANAGE,
  PERMISSION_READ,
  PERMISSION_ASSIGN,
];

export const MAINTENANCE_PERMISSIONS = [
  MAINTENANCE_READ,
  MAINTENANCE_CREATE,
  MAINTENANCE_UPDATE,
  MAINTENANCE_DELETE,
  MAINTENANCE_MANAGE,
];

export const CONSUMABLES_PERMISSIONS = [
  CONSUMABLES_READ,
  CONSUMABLES_CREATE,
  CONSUMABLES_UPDATE,
  CONSUMABLES_DELETE,
];

export const SPARE_PART_PERMISSIONS = [
  SPARE_PART_READ,
  SPARE_PART_CREATE,
  SPARE_PART_UPDATE,
  SPARE_PART_DELETE,
];

export const TOOL_PERMISSIONS = [
  TOOL_READ,
  TOOL_CREATE,
  TOOL_UPDATE,
  TOOL_DELETE,
];

export const VENDOR_PERMISSIONS = [
  VENDOR_READ,
  VENDOR_CREATE,
  VENDOR_UPDATE,
  VENDOR_DELETE,
];

export const LOCATION_PERMISSIONS = [
  LOCATION_READ,
  LOCATION_CREATE,
  LOCATION_UPDATE,
  LOCATION_DELETE,
];

export const WARRANTY_PERMISSIONS = [
  WARRANTY_READ,
  WARRANTY_CREATE,
  WARRANTY_UPDATE,
  WARRANTY_DELETE,
];

export const TAG_PERMISSIONS = [
  TAG_READ,
  TAG_CREATE,
  TAG_UPDATE,
  TAG_DELETE,
];

export const EQUIPMENT_PERMISSIONS = [
  EQUIPMENT_READ,
  EQUIPMENT_CREATE,
  EQUIPMENT_UPDATE,
  EQUIPMENT_DELETE,
];

export const EQUIPMENT_REQUEST_PERMISSIONS = [
  EQUIPMENT_REQUEST_READ,
  EQUIPMENT_REQUEST_CREATE,
  EQUIPMENT_REQUEST_UPDATE,
  EQUIPMENT_REQUEST_DELETE,
];

export const NOTIFICATION_PERMISSIONS = [
  NOTIFICATION_READ,
  NOTIFICATION_CREATE,
  NOTIFICATION_DELETE,
];

export const ATTENDANCE_PERMISSIONS = [
  ATTENDANCE_READ,
  ATTENDANCE_CREATE,
  ATTENDANCE_UPDATE,
];

export const REPORT_PERMISSIONS = [
  REPORT_VIEW,
  REPORT_EXPORT,
  COST_REPORT_VIEW,
];

export const DEPARTMENT_PERMISSIONS = [
  DEPARTMENT_READ,
  DEPARTMENT_MANAGE,
];

export const SERVICE_CONTRACT_PERMISSIONS = [
  SERVICE_CONTRACT_READ,
  SERVICE_CONTRACT_CREATE,
  SERVICE_CONTRACT_UPDATE,
  SERVICE_CONTRACT_DELETE,
];

export const SERVICE_REQUEST_PERMISSIONS = [
  SERVICE_REQUEST_READ,
  SERVICE_REQUEST_CREATE,
  SERVICE_REQUEST_UPDATE,
  SERVICE_REQUEST_DELETE,
];

export const ESCALATION_PERMISSIONS = [
  ESCALATION_READ,
  ESCALATION_CREATE,
  ESCALATION_UPDATE,
  ESCALATION_DELETE,
];

export const METER_PERMISSIONS = [
  METER_READ,
  METER_CREATE,
  METER_UPDATE,
  METER_DELETE,
];

export const CATEGORY_PERMISSIONS = [
  CATEGORY_READ,
  CATEGORY_CREATE,
  CATEGORY_UPDATE,
  CATEGORY_DELETE,
];

export const ASSET_TYPE_PERMISSIONS = [
  ASSET_TYPE_READ,
  ASSET_TYPE_CREATE,
  ASSET_TYPE_UPDATE,
  ASSET_TYPE_DELETE,
];

export const CUSTOM_FIELD_PERMISSIONS = [
  CUSTOM_FIELD_CREATE,
  CUSTOM_FIELD_UPDATE,
  CUSTOM_FIELD_DELETE,
];

export const MATERIOVIGILANCE_PERMISSIONS = [
  MATERIOVIGILANCE_READ,
  MATERIOVIGILANCE_CREATE,
  MATERIOVIGILANCE_UPDATE,
  MATERIOVIGILANCE_DELETE,
  MATERIOVIGILANCE_CLOSE,
  MATERIOVIGILANCE_REOPEN,
];

export const DOCUMENT_VAULT_PERMISSIONS = [
  DOCUMENT_VAULT_READ,
  DOCUMENT_VAULT_CREATE,
  DOCUMENT_VAULT_UPDATE,
  DOCUMENT_VAULT_DELETE,
];

export const TEAM_PERMISSIONS = [
  TEAM_READ,
  TEAM_CREATE,
  TEAM_UPDATE,
  TEAM_DELETE,
  TEAM_MANAGE_MEMBERS,
];

// =========================================
// Role Constants
// =========================================
export const ROLES = {
  SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ADMINISTRATOR: 'ROLE_ADMINISTRATOR',
  FULL_USER: 'ROLE_FULL_USER',
  REQUESTOR: 'ROLE_REQUESTOR',
  DEFAULT: 'ROLE_DEFAULT',
  GLOBAL_LEADER: 'ROLE_GLOBAL_LEADER',
};

// Multi-org aggregate view (formerly Global Organizations).
// A user with this permission in 2+ of their org memberships sees the
// "Global View" entry in the org switcher.
export const ORG_AGGREGATE_VIEW = 'org:aggregate-view';
export const USER_MEMBERSHIP_MANAGE = 'user-membership:manage';

// @deprecated Replaced by {@link ORG_AGGREGATE_VIEW}. Kept temporarily so any
// stale tokens still resolve. Do not use in new code.
export const GLOBAL_ORG_READ = 'global-org:read';
export const GLOBAL_ORG_MANAGE = 'global-org:manage';

// Legacy role mappings (for backward compatibility)
export const LEGACY_ADMIN_ROLES = [
  'ROLE_HOD',
  'ROLE_BMD_HOD',
  'ROLE_HOSPITAL_ADMIN',
  'ROLE_COO',
];

// Legacy BME role mapping
export const LEGACY_BME_ROLE = 'ROLE_BME';

// Web Portal allowed system roles (for filtering)
export const WEB_PORTAL_ALLOWED_ROLES = [
  ROLES.ADMINISTRATOR,
  ROLES.FULL_USER,
  ROLES.REQUESTOR,
];

/**
 * Check if a role is an admin-level role.
 * @param {string} role - The role to check
 * @returns {boolean}
 */
export const isAdminRole = (role) => {
  return role === ROLES.SUPER_ADMIN ||
         role === ROLES.ADMINISTRATOR ||
         LEGACY_ADMIN_ROLES.includes(role);
};

/**
 * Check if a role is the super admin role.
 * @param {string} role - The role to check
 * @returns {boolean}
 */
export const isSuperAdminRole = (role) => {
  return role === ROLES.SUPER_ADMIN;
};

/**
 * Check if a role is a full user role (including legacy ROLE_BME).
 * @param {string} role - The role to check
 * @returns {boolean}
 */
export const isFullUserRole = (role) => {
  return role === ROLES.FULL_USER || role === LEGACY_BME_ROLE;
};

/**
 * Get display name for a permission.
 * @param {string} permission - The permission string (e.g., 'asset:read')
 * @returns {string} - Human-readable name (e.g., 'Read Asset')
 */
export const getPermissionDisplayName = (permission) => {
  if (!permission) return '';
  const parts = permission.split(':');
  if (parts.length !== 2) return permission;

  const [resource, action] = parts;
  const capitalizedAction = action.charAt(0).toUpperCase() + action.slice(1);
  const capitalizedResource = resource.split('-').map(
    word => word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');

  return `${capitalizedAction} ${capitalizedResource}`;
};

/**
 * Get all permissions as an object for easy lookup.
 */
export const Permissions = {
  // Asset
  assetRead: ASSET_READ,
  assetCreate: ASSET_CREATE,
  assetUpdate: ASSET_UPDATE,
  assetDelete: ASSET_DELETE,
  // Asset Issue
  assetIssueRead: ASSET_ISSUE_READ,
  assetIssueCreate: ASSET_ISSUE_CREATE,
  assetIssueUpdate: ASSET_ISSUE_UPDATE,
  assetIssueDelete: ASSET_ISSUE_DELETE,
  assetIssueAssign: ASSET_ISSUE_ASSIGN,
  // Service
  serviceRead: SERVICE_READ,
  serviceCreate: SERVICE_CREATE,
  serviceUpdate: SERVICE_UPDATE,
  serviceDelete: SERVICE_DELETE,
  serviceAssign: SERVICE_ASSIGN,
  // Preventive
  preventiveRead: PREVENTIVE_READ,
  preventiveCreate: PREVENTIVE_CREATE,
  preventiveUpdate: PREVENTIVE_UPDATE,
  preventiveDelete: PREVENTIVE_DELETE,
  preventiveAssign: PREVENTIVE_ASSIGN,
  // Recall
  recallRead: RECALL_READ,
  recallCreate: RECALL_CREATE,
  recallUpdate: RECALL_UPDATE,
  recallDelete: RECALL_DELETE,
  recallAssign: RECALL_ASSIGN,
  // Routine
  routineRead: ROUTINE_READ,
  routineCreate: ROUTINE_CREATE,
  routineUpdate: ROUTINE_UPDATE,
  routineDelete: ROUTINE_DELETE,
  // Calibration
  calibrationRead: CALIBRATION_READ,
  calibrationCreate: CALIBRATION_CREATE,
  calibrationUpdate: CALIBRATION_UPDATE,
  calibrationDelete: CALIBRATION_DELETE,
  // Testing
  testingRead: TESTING_READ,
  testingCreate: TESTING_CREATE,
  testingUpdate: TESTING_UPDATE,
  testingDelete: TESTING_DELETE,
  // User
  userRead: USER_READ,
  userCreate: USER_CREATE,
  userUpdate: USER_UPDATE,
  userDelete: USER_DELETE,
  // Organization
  organizationRead: ORGANIZATION_READ,
  organizationManage: ORGANIZATION_MANAGE,
  // Role & Permission
  roleRead: ROLE_READ,
  roleManage: ROLE_MANAGE,
  permissionRead: PERMISSION_READ,
  permissionAssign: PERMISSION_ASSIGN,
  // Maintenance
  maintenanceRead: MAINTENANCE_READ,
  maintenanceCreate: MAINTENANCE_CREATE,
  maintenanceUpdate: MAINTENANCE_UPDATE,
  maintenanceDelete: MAINTENANCE_DELETE,
  maintenanceManage: MAINTENANCE_MANAGE,
  // Consumables
  consumablesRead: CONSUMABLES_READ,
  consumablesCreate: CONSUMABLES_CREATE,
  consumablesUpdate: CONSUMABLES_UPDATE,
  consumablesDelete: CONSUMABLES_DELETE,
  // Spare Parts
  sparePartRead: SPARE_PART_READ,
  sparePartCreate: SPARE_PART_CREATE,
  sparePartUpdate: SPARE_PART_UPDATE,
  sparePartDelete: SPARE_PART_DELETE,
  // Tools
  toolRead: TOOL_READ,
  toolCreate: TOOL_CREATE,
  toolUpdate: TOOL_UPDATE,
  toolDelete: TOOL_DELETE,
  // Vendor
  vendorRead: VENDOR_READ,
  vendorCreate: VENDOR_CREATE,
  vendorUpdate: VENDOR_UPDATE,
  vendorDelete: VENDOR_DELETE,
  // Location
  locationRead: LOCATION_READ,
  locationCreate: LOCATION_CREATE,
  locationUpdate: LOCATION_UPDATE,
  locationDelete: LOCATION_DELETE,
  // Warranty
  warrantyRead: WARRANTY_READ,
  warrantyCreate: WARRANTY_CREATE,
  warrantyUpdate: WARRANTY_UPDATE,
  warrantyDelete: WARRANTY_DELETE,
  // Tag
  tagRead: TAG_READ,
  tagCreate: TAG_CREATE,
  tagUpdate: TAG_UPDATE,
  tagDelete: TAG_DELETE,
  // Equipment
  equipmentRead: EQUIPMENT_READ,
  equipmentCreate: EQUIPMENT_CREATE,
  equipmentUpdate: EQUIPMENT_UPDATE,
  equipmentDelete: EQUIPMENT_DELETE,
  // Equipment Request
  equipmentRequestRead: EQUIPMENT_REQUEST_READ,
  equipmentRequestCreate: EQUIPMENT_REQUEST_CREATE,
  equipmentRequestUpdate: EQUIPMENT_REQUEST_UPDATE,
  equipmentRequestDelete: EQUIPMENT_REQUEST_DELETE,
  // Notification
  notificationRead: NOTIFICATION_READ,
  notificationCreate: NOTIFICATION_CREATE,
  notificationDelete: NOTIFICATION_DELETE,
  // Attendance
  attendanceRead: ATTENDANCE_READ,
  attendanceCreate: ATTENDANCE_CREATE,
  attendanceUpdate: ATTENDANCE_UPDATE,
  // Activity
  activityRead: ACTIVITY_READ,
  // Reports
  reportView: REPORT_VIEW,
  reportExport: REPORT_EXPORT,
  costReportView: COST_REPORT_VIEW,
  // Department
  departmentRead: DEPARTMENT_READ,
  departmentManage: DEPARTMENT_MANAGE,
  // Service Contract
  serviceContractRead: SERVICE_CONTRACT_READ,
  serviceContractCreate: SERVICE_CONTRACT_CREATE,
  serviceContractUpdate: SERVICE_CONTRACT_UPDATE,
  serviceContractDelete: SERVICE_CONTRACT_DELETE,
  // Escalation
  escalationRead: ESCALATION_READ,
  escalationCreate: ESCALATION_CREATE,
  escalationUpdate: ESCALATION_UPDATE,
  escalationDelete: ESCALATION_DELETE,
  // Service Request
  serviceRequestRead: SERVICE_REQUEST_READ,
  serviceRequestCreate: SERVICE_REQUEST_CREATE,
  serviceRequestUpdate: SERVICE_REQUEST_UPDATE,
  serviceRequestDelete: SERVICE_REQUEST_DELETE,
  // Category
  categoryRead: CATEGORY_READ,
  categoryCreate: CATEGORY_CREATE,
  categoryUpdate: CATEGORY_UPDATE,
  categoryDelete: CATEGORY_DELETE,
  // Asset Type
  assetTypeRead: ASSET_TYPE_READ,
  assetTypeCreate: ASSET_TYPE_CREATE,
  assetTypeUpdate: ASSET_TYPE_UPDATE,
  assetTypeDelete: ASSET_TYPE_DELETE,
  // Meter
  meterRead: METER_READ,
  meterCreate: METER_CREATE,
  meterUpdate: METER_UPDATE,
  meterDelete: METER_DELETE,
  // Document Vault (Compliance)
  documentVaultRead: DOCUMENT_VAULT_READ,
  documentVaultCreate: DOCUMENT_VAULT_CREATE,
  documentVaultUpdate: DOCUMENT_VAULT_UPDATE,
  documentVaultDelete: DOCUMENT_VAULT_DELETE,
};

export default Permissions;
